import { Logger } from "aws-amplify"
const logger = new Logger("WEBSOCKET STORE")

/**
 * some quick info on our websocket info. 
 * 
 * EVENT HANDLERS
 * socket handlers are used to process data when it arrives on the websocket. each message with have an "action" property. 
 * when you register an event handler, we pass a simple object { action: HandlerFunction(messageData) }
 * 
 * SUBSCRIPTIONS
 * often we make API calls to state we want to recieve messages over the websocket about certain events.
 * in order to make sure we don't loose these conections when the web socket is disconnected and has to be recreated, we register subscriptions.
 * a subscription is a simple object with a name property, a subscribe function, and a refresh function. 
 * e.g { 
 *  name: 'vehicleUpdates', 
 *  subscribe: (socketID) => *usually an api request that uses the socketID to request web socket updates*, 
 *  refresh: () => *function to determine if this event still needs to be refreshed. for some events like vehicle presence, this simply returns true* 
 * }
 */

export default {
  // adds a web socket handler 
  addSocketEventHandler: (state, listener) => {
    const key = Object.keys(listener)[0] // we pass listeners like { eventName: Handler }
    logger.debug(`web socket handler added for ${key}`)
    state.socketEventHandlers[key] = listener[key]
  },

  // adds a subscription to the web socket
  registerSocketSubscription: (state, subscription) => {
    const existingSubs = state.socketSubscriptions.map(i => i.name)

    // if a refresh property was not provided, we add a default function that will always return true. 
    // this sub will always be renewed when a websocket connection is created
    if(typeof subscription.refresh !== 'function') {
      subscription.refresh = () => true
    }

    if(existingSubs.includes(subscription.name)) {
      logger.debug(`subscription for ${subscription.name} has already been registered. the old subscription will be overwritten.`)
      const index = existingSubs.indexOf(subscription.name)
      state.socketSubscriptions[index] = subscription
      return
    }

    if(subscription.subscribe) {
      logger.debug(`socket subscription added for ${subscription.name}`, subscription)
      state.socketSubscriptions.push(subscription)
    } else {
      logger.debug("socket subscription was missing either subscribe function", subscription)
    }
  },

  // removes socketSubscriptions that are no longer required
  removeOldSubscriptions: (state) => {
    state.socketSubscriptions =  state.socketSubscriptions.filter(i => {
      try {
        return i.refresh()
      } catch {
        logger.debug("socket subscription was removed because the refresh function failed", i)
        return false
      }
    })
  },

  // updates the web socket connection id after a connection is made
  setSocketID: (state, socketID) => {
    logger.debug("web socket id set to", socketID)
    state.connectionID = socketID
  },

  // updates the web socket connection id after a connection is made
  setState: (state, newState) => {
    logger.debug("web socket state set to", newState)
    state.currentState = newState
  },

  addActiveSubscription: (state, subName) => {
    state.activeSubscriptions.push(subName)
  },

  resetActiveSubscriptions: (state) => {
    state.activeSubscriptions = []
  },

  setSocket: (state, socket) => {
    state.webSocket = socket
  },

  manualRefresh: (state) => {
    logger.debug("manual refresh called")
    state.manualRefresh = state.manualRefresh + 1
  }
}